import { doc, setDoc } from 'firebase/firestore';
import { User } from 'firebase/auth';
import { firestore } from '~/firebase/init';
import { Customer } from '~/types/platform/customer';

export default async function updatePlatformCustomer(
  platformId: string,
  auth: User,
  data: Partial<Customer>,
) {
  const ref = doc(firestore, 'platforms', platformId, 'customers', auth.uid);

  await setDoc(ref, data, { merge: true });
}
